module.exports = __webpack_public_path__ + "static/media/natalia_makarova.5fcbcf46.jpg";